import axios from 'axios'

import API from 'constants/api'

const VCC_LEADERBOARD_PLAYERS_PATH = '/api/v1/vcc-dashboard/leaderboard/players'
const VCC_AUTH_EXCHANGE_PATH = '/api/v1/vcc-dashboard/auth/exchange_token'
const ADMIN_TOKEN_STORAGE_KEY = 'vcc_admin_access_token'
const DEFAULT_LEADERBOARD_LIMIT = 100

function normalizeBaseUrl(url) {
  return url ? url.replace(/\/$/, '') : ''
}

function adminAuthHeader(token = localStorage.getItem(ADMIN_TOKEN_STORAGE_KEY)) {
  return token ? { Authorization: `Bearer ${token}` } : {}
}

function adminBaseUrl() {
  const baseUrl = normalizeBaseUrl(API.ADMIN_API_URL)

  if (!baseUrl) {
    throw new Error('Missing PlayLearning Admin API URL')
  }

  return baseUrl
}

export async function exchangePlaylearningAdminToken(auth0AccessToken) {
  if (!auth0AccessToken) return null

  const { data } = await axios.post(
    `${adminBaseUrl()}${VCC_AUTH_EXCHANGE_PATH}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${auth0AccessToken}`
      }
    }
  )

  if (data?.access_token) {
    localStorage.setItem(ADMIN_TOKEN_STORAGE_KEY, data.access_token)
  }

  return data?.access_token || null
}

async function ensurePlaylearningAdminToken(getAuth0AccessToken) {
  const existingToken = localStorage.getItem(ADMIN_TOKEN_STORAGE_KEY)
  if (existingToken) return existingToken
  if (!getAuth0AccessToken) return null

  const auth0AccessToken = await getAuth0AccessToken()
  return exchangePlaylearningAdminToken(auth0AccessToken)
}

async function requestLeaderboardPlayers(baseUrl, limit, token) {
  const { data } = await axios.get(`${baseUrl}${VCC_LEADERBOARD_PLAYERS_PATH}`, {
    headers: adminAuthHeader(token),
    params: { limit }
  })

  return data
}

export async function fetchVccLeaderboardPlayers(limit = DEFAULT_LEADERBOARD_LIMIT, options = {}) {
  const baseUrl = adminBaseUrl()
  const { getAuth0AccessToken } = options
  const token = await ensurePlaylearningAdminToken(getAuth0AccessToken)

  try {
    return await requestLeaderboardPlayers(baseUrl, limit, token)
  } catch (error) {
    if (error.response?.status !== 401 || !getAuth0AccessToken) throw error

    localStorage.removeItem(ADMIN_TOKEN_STORAGE_KEY)
    const auth0AccessToken = await getAuth0AccessToken()
    const refreshedToken = await exchangePlaylearningAdminToken(auth0AccessToken)
    return requestLeaderboardPlayers(baseUrl, limit, refreshedToken)
  }
}

export default fetchVccLeaderboardPlayers
